type RegistryView = {
  registrant_first_name?: string | null;
  partner_registrant_first_name?: string | null;
}

/**
 * Get the couple name from a registry-like object
 */
export const getCoupleName = (registry?: RegistryView | null): string => {
  const {
    registrant_first_name: registrantFirstName,
    partner_registrant_first_name: partnerRegistrantFirstName,
  } = registry || {};
  let coupleName = 'The couple';
  if (partnerRegistrantFirstName) {
    coupleName = `${registrantFirstName} and ${partnerRegistrantFirstName}`;
  } else if (registrantFirstName) {
    coupleName = registrantFirstName;
  }
  return coupleName;
};

/**
 * Get the gift notification title from a registry-like object
 */
export const getGiftNotificationTitle = (
  registry?: RegistryView | null,
  isCashFund?: boolean
): string => {
  const {
    registrant_first_name: registrantFirstName,
    partner_registrant_first_name: partnerRegistrantFirstName,
  } = registry || {};
  let prefix = 'The couple has';
  if (partnerRegistrantFirstName) {
    prefix = `${registrantFirstName} and ${partnerRegistrantFirstName} have`;
  } else if (registrantFirstName) {
    prefix = `${registrantFirstName} has`;
  }
  const suffix = isCashFund ? 'contribution' : 'gift';
  return `${prefix} been notified of your ${suffix}.`;
};
